var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColumns2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 2.5H6.5V13.5H2.5V2.5ZM1.5 2.5C1.5 1.94769 1.94775 1.5 2.5 1.5L6.5 1.5C7.05225 1.5 7.5 1.94769 7.5 2.5V13.5C7.5 14.0523 7.05225 14.5 6.5 14.5H2.5C1.94775 14.5 1.5 14.0523 1.5 13.5V2.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 2.5H13.5V13.5H9.5V2.5ZM8.5 2.5C8.5 1.94769 8.94775 1.5 9.5 1.5L13.5 1.5C14.0522 1.5 14.5 1.94769 14.5 2.5V13.5C14.5 14.0523 14.0522 14.5 13.5 14.5H9.5C8.94775 14.5 8.5 14.0523 8.5 13.5V2.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgColumns2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/columns-2.0c3bb90a028ab093fa4f69e2bb48398d.svg";